// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"fb5a2ded","453":"b9c46ee6","726":"f458fb75"}[chunkId] + ".chunk.js";
};